import { safeboxClient } from 'myNet'

const ROUTE = '/v1/groups'

interface ApiResponse<T = any> {
  code: number
  message: string
  data?: T
}

interface ErrorWithCode extends Error {
  code: number
}

const GroupService = {
  get: async (request?: any): Promise<ApiResponse> => {
    const response = await safeboxClient.get(`${ROUTE}`, request)
    const { code, message } = response.data
    if (code !== 200) {
      const err = new Error(message) as ErrorWithCode
      err.code = code
      throw err
    }
    return response.data
  },
}

export default GroupService
